import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query';
import {customReducer} from '../api/customerAPI'
import {licenseReducer} from '../api/licenseAPI'
import {appReducer} from '../api/appAPI'
import {reportReducer} from '../api/reportAPI'
import stroageDataSlice from './stroageData'
import { rtkQueryErrorLogger } from '../utils/request'


const store =  configureStore({
  reducer: {
    [customReducer.reducerPath]: customReducer.reducer,
    [licenseReducer.reducerPath]: licenseReducer.reducer,
    [appReducer.reducerPath]: appReducer.reducer,
    [reportReducer.reducerPath]: reportReducer.reducer,stroageDataSlice,
    [stroageDataSlice.name]:stroageDataSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(customReducer.middleware,licenseReducer.middleware,appReducer.middleware,reportReducer.middleware,rtkQueryErrorLogger),
})

setupListeners(store.dispatch);

export default store;